import { fitBounds } from "google-map-react/utils";

export const UPSELL_GPS = {
  lat: 48.816669,
  lng: 2.31667
};

//gps = [{lat:39, lng:293}]
export const computeCenterAndZoomOfListOfGps = (gps = [], mapWidth = 260, mapHeight = 197) => {
  if (gps.length < 1) {
    return {
      center: {
        lat: UPSELL_GPS.lat,
        lng: UPSELL_GPS.lng
      },
      zoom: 6
    };
  } else {
    const minLat = gps.reduce((prev, curr) => (prev.lat < curr.lat ? prev : curr)).lat;
    const minLng = gps.reduce((prev, curr) => (prev.lng < curr.lng ? prev : curr)).lng;
    const maxLat = gps.reduce((prev, curr) => (prev.lat > curr.lat ? prev : curr)).lat;
    const maxLng = gps.reduce((prev, curr) => (prev.lng > curr.lng ? prev : curr)).lng;
    const bounds = {
      nw: {
        lat: maxLat,
        lng: minLng
      },
      se: {
        lat: minLat,
        lng: maxLng
      }
    };
    return fitBounds(bounds, { width: mapWidth, height: mapHeight });
  }
};



// WEBPACK FOOTER //
// src/modules/presence/utils/map.utils.js